import { createApiCall } from 'lib/base';

const FETCH_MARKET_INDEX_EDIT_API_ID =
  'DASHBOARD/FETCH_MARKET_INDEX_EDIT_API';

const apiCall = createApiCall(
  FETCH_MARKET_INDEX_EDIT_API_ID,
  ({ id, payload }) => ({
    endpoint: `/api/admin/market-indexes/${id}`,
    method: 'PATCH',
    body: payload,
    notify: true,
  })
);

export default apiCall;
